import React, { useState, useEffect, useMemo } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import {
  reRegistrationListFilter,
  reRegistrationDelete,
  GetReRegistrationListCancelToken
} from "../../../services/RegistrationService";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import Tablefilter from "../../common/Tablefilter";
import { RenderSchool } from "../../../utils/CommonGroupingItem";
import { RenderAssessmentStatus } from "../../../utils/CommonStatusItems";
import { TABLE_DATE_FORMAT, TABLE_ROWS_PER_PAGE, TABLE_TIME_FORMAT } from "../../../utils/Constants";
import axios from "axios";
import { handleTableScroll } from "../../../utils/commonFunction";
import { formatTableDate } from "../../../utils/dateHelpers";


const ListReRegistration = () => {

  const history = useHistory();

  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(false);

  const [intakeArr, setIntakeArr] = useState([]);
  const [deleteRow, setDeleteRow] = useState(false);
  const [dropdownValues, setDropdownValues] = useState(
    useSelector((state) => state.registerDropdownValues)
  );
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const sortKey = "id";
  const sortDir = "desc";
  const [listData, setListData] = useState({
    data: [],
    total: 0,
  });

  const [schoolArr, setSchoolArr] = useState([]);
  const [statusArr, setStatusArr] = useState([]);
  const [searchSchoolCheck, setSearchSchoolCheck] = useState({});
  const [intake, setIntake] = useState({ arr: [], checkObj: {} })
  const [status, setStatus] = useState({ arr: [], checkObj: {} })
  const [school, setSchool] = useState({ arr: [], checkObj: {} })

  useEffect(() => {
    handleTableScroll()
  }, [loading])
  useEffect(() => {
    const source = axios.CancelToken.source();

    const getData = async () => {
      try {
        setLoading(true);

        const payload = {
          key: sortKey,
          sort: sortDir,
          exportStatus: "false",
          search,
          page,
          limit,
          viaStatus: status.arr,
          viaIntake: intake.arr,
          viaSchool: school.arr,
        };

        const res = await GetReRegistrationListCancelToken(payload, source.token);
        const apiData = res?.data?.data ?? { data: [], total: 0 };
        setListData(apiData);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      } finally {
        setLoading(false);
      }
    };

    getData();

    return () => {
      source.cancel("ListReRegistration: new request / unmount");
    };
  }, [
    deleteRow,
    search,
    page,
    limit,
    status.arr,
    intake.arr,
    school.arr,
  ]);

  useEffect(() => {
    const storedFilters = JSON.parse(localStorage.getItem("filterStateReregList"));
    if (storedFilters) {
      setStatus(storedFilters.status);
      setIntake(storedFilters.intake);
      setSchool(storedFilters.school);
    }
  }, []);
  useEffect(() => {
    const filterState = {
      status,
      school,
      intake
    };
    localStorage.setItem("filterStateReregList", JSON.stringify(filterState));
  }, [status, school, intake]);

  useEffect(() => {
    setPage(1);
  }, [search, status.arr, intake.arr, school.arr, limit]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    const fetchFilters = async () => {
      try {
        const res = await reRegistrationListFilter(source.token);

        setIntakeArr(res?.data?.data?.yearsAndIntakesFilter || []);
        setSchoolArr(res?.data?.data?.schoolFilters || []);
        setStatusArr(res?.data?.data?.statusFilters || []);

      } catch (error) {
        if (!axios.isCancel(error)) console.error(error);
      }
    };

    fetchFilters();

    return () => {
      source.cancel("Component unmounted");
    };
  }, [deleteRow]);

  function getValue(arrName, label) {
    let labelName = "";
    for (let item of dropdownValues[arrName]) {
      if (item.value.toString() == label.toString()) {
        labelName = item.label;
        break;
      }
    }

    if (labelName === "" && arrName === "re_registration_status") return label;
    return labelName;
  }

  const sortingIntake = (rowA, rowB) => {
    const intake1 = (rowA?.intake_year && rowA.intake_number)
      ? rowA.intake_year + "-" + rowA.intake_number
      : "";
    const intake2 = (rowB?.intake_year && rowB.intake_number)
      ? rowB.intake_year + "-" + rowB.intake_number
      : "";
    return intake1.localeCompare(intake2);
  };
  const sortingDescription = (rowA, rowB) => {
    const name1 = rowA?.description ? rowA.description : "";
    const name2 = rowB?.description ? rowB.description : "";
    return name1.localeCompare(name2);
  };
  const columns = useMemo(() => [
    {
      name: "Description",
      selector: "description",
      sortable: true,
      sortFunction: sortingDescription,
      cell: (row) => (
        <Link
          className="as-text-blue curser feature-name"
          title={row.description}
          to={`/courseAdministration/registration/open-re-registration/open/${row.id}?description=${row.description}`}
        >
          <span className="textLimit100">{row.description}</span>
        </Link>
      ),
    },
    {
      name: "School",
      selector: "academy_type",
      sortable: true,
      cell: (row) => row.academy_type ? <span className="feature-name"><span className="textLimit100">{RenderSchool(row.academy_type).html} </span></span> : "-"
    },
    {
      name: "Intake",
      selector: "intake_year",
      sortable: true,
      sortFunction: sortingIntake,
      cell: (row) => row.intake_year + "-" + row.intake_number,
    },
    {
      name: "Start",
      selector: "start_date",
      sortable: true,
      cell: (row) => formatTableDate(row.start_date),
    },
    {
      name: "End",
      selector: "end_date",
      sortable: true,
      cell: (row) => formatTableDate(row.end_date),
    },
    {
      name: "Hard Launch",
      selector: "hard_launch",
      sortable: true,
      cell: (row) => formatTableDate(row.hard_launch),
    },
    {
      name: "Late Re-Reg End",
      selector: "late_rereg_end",
      sortable: true,
      cell: (row) => formatTableDate(row.late_rereg_end),
    },
    {
      name: "Students",
      selector: "totalStudent",
      sortable: true,
      cell: (row) => (row.totalStudent != null ? row.totalStudent : 0),
    },
    {
      name: "Students Interested",
      selector: "interestedStudent",
      sortable: true,
      cell: (row) => (row.interestedStudent != null ? row.interestedStudent : 0),
    },

    {
      name: "Status",
      selector: "reg_status",
      sortable: true,
      cell: (row) => row.reg_status ? RenderAssessmentStatus(row.reg_status).html : "-",
    },

    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08  btn-dropdown-grp">
          <div className="as-buttons d-flex">
            <Link
              to={`/courseAdministration/registration/open-re-registration/open/${row.id}?description=${row.description}`}
              title="Open"
              className="btn btn-primary rounded-circle"
            >
              <i className="fal fa-folder-open"></i>
            </Link>
            <button
              title="Delete"
              className="btn btn-danger rounded-circle"
              onClick={() => handleDelete(row.id)}
            >
              <i className="fal fa-trash-alt"></i>
            </button>
          </div>
        </div>
      ),
    },
  ]);

  const handleDelete = (ID) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          reRegistrationDelete(ID).then((res) => {
            setDeleteRow(!deleteRow);
          });

          Swal.fire("Deleted!", "Re-Registration has been deleted.", "success");
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        setDeleteRow(!deleteRow);
        history.push("/administration/brandSetting/list");
      });
  };

  function resetFilter() {
    setSearch("");
    setSchool({ arr: [], checkObj: {} })
    setIntake({ arr: [], checkObj: {} })
    setStatus({ arr: [], checkObj: {} })
  }

  const handleFilters = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const exportData = (fileType, fileName) => {
    let data = listData.data || [];
    const header = [
      "Description",
      "School",
      "Intake",
      "Start",
      "End",
      "Status",
    ];

    data = data?.map((row) => ({
      ...row,
      School: row.academy_type ? getValue("academy", row.academy_type) : "-",
      Description: row?.description ? row?.description : "-",
      Intake: row.intake_year
        ? row.intake_year + "-" + row.intake_number
        : "-",
      "Start": formatTableDate(row.start_date),
      "End": formatTableDate(row.end_date),
      Status: row.reg_status ? row.reg_status : "-",
    }));

    if (fileType === "csv") {
      const csvString = Papa.unparse({ fields: header, data });
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

      const blobURL = window.URL.createObjectURL(blob);

      const anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = blobURL;
      anchor.dataset.downloadurl = [
        "text/csv",
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();

      setTimeout(() => {
        URL.revokeObjectURL(blobURL);
      }, 1000);
    } else if (fileType === "xlsx") {
      const compatibleData = data.map((row) => {
        const obj = {};
        header.map((col, index) => {
          obj[col] = row[col];
        });
        return obj;
      });

      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });
      XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
      XLSX.writeFile(wb, `${fileName}.xlsx`);

      return false;
    }
    if (fileType === "pdf") {
      const compatibleData = data.map((row) => {
        return [
          row["Description"],
          row["School"],
          row["Intake"],
          row["Start"],
          row["End"],
          row["Status"],
        ];
      });
      const doc = new JsPDF();
      doc.autoTable({
        head: [header],
        body: compatibleData,
        styles: {
          minCellHeight: 10,
          minCellWidth: 5,
          halign: "left",
          fontSize: 8,
        },
      });
      doc.save(`${fileName}.pdf`);

      return false;
    }
  };

  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
      <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">

        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div
                  id="assessment-table-main_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div
                    id="assessment-table-main_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      <input
                        type="search"
                        className=""
                        placeholder="Search"
                        aria-controls="assessment-table-main"
                        onChange={(e) => handleFilters(e)}
                        value={search}
                      />
                    </label>
                    <div className="filter-eff filter-data-btn">
                      <button className="filter-buttons">
                        <i className="fal fa-filter"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                <div className="filter-scroll">
                  <div className={`filter-scroll-inner  filter-custom-new`}>
                    <Tablefilter
                      filterName={"Status"}
                      optionArr={statusArr}
                      state={status}
                      setState={setStatus}
                      renderLabelFunction={RenderAssessmentStatus}
                    />
                    <Tablefilter
                      filterName={"School"}
                      optionArr={schoolArr}
                      state={school}
                      setState={setSchool}
                      renderLabelFunction={RenderSchool}
                    />
                    <Tablefilter
                      filterName={"Intake"}
                      optionArr={intakeArr}
                      state={intake}
                      setState={setIntake}
                      isOptionReversed={true}
                    />
                  </div>
                </div>
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      title="Reset"
                      onClick={resetFilter}
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("xlsx", "Registration List");
                      }}
                      title="Export spreadsheet"
                    >
                      <i className="fal fa-file-excel icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("csv", "Registration List");
                      }}
                      title="Export CSV"
                    >
                      <i className="fal fa-file-csv icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("pdf", "Registration List");
                      }}
                      title="Export PDF"
                    >
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="search-filter-div-right">
            <div className=" filter-search-bar-blk">
              <div className="add-ticket-blk button-reset dropdown-comman">
                <Link
                  to={`/courseAdministration/registration/open-re-registration/add`}
                >
                  <button className="btn btn-primary" title="Create New">
                    <i className="fal fa-plus"></i>Create New
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          data={listData.data}
          columns={columns}
          progressPending={loading}
          progressComponent={<SkeletonTicketList />}
          pagination
          paginationServer
          paginationTotalRows={listData.total}
          onChangePage={(p) => setPage(p)}
          onChangeRowsPerPage={(newLimit, p) => {
            setLimit(newLimit);
            setPage(p);
          }}
          paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        />
      </div>
    </div>
  );
};

export default ListReRegistration;